import React, {useEffect, useRef, useState} from "react";
import {LookDataType} from "./LookTypes";

type LookItemType = {
  href: string;
  look: LookDataType;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  openFilter?: boolean;
};

const LookItem: React.FC<LookItemType> = ({href, look, onClick, openFilter}) => {
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (imageRef.current && imageRef.current.src === look.image && imageRef.current.complete) {
      setImageLoaded(true);
    } else {
      setImageLoaded(false);
    }
  }, [look]);

  const onImageLoad: React.ReactEventHandler<HTMLImageElement> = () => {
    setImageLoaded(true);
  };

  const coordinates =
    look.products?.map((product) => ({
      x: product.coordinates.x,
      y: product.coordinates.y,
      productId: product.productId,
    })) || [];

  let className = "swiper-look-link";
  if (typeof openFilter !== "undefined") {
    className += ` column-8 column-s-4 column-m-2 ${openFilter ? "column-l-4" : "column-l-3"}`;
  }

  return (
    <a href={href} className={className} onClick={onClick} title={look.title}>
      <div className="container">
        <div className="image-container">
          <img
            src={look.image}
            onLoad={onImageLoad}
            alt={look.title}
            className="main-image"
            ref={imageRef}
            loading="lazy"
          />

          {/* Product dots */}
          {imageLoaded &&
            coordinates.map((coord, index) => (
              <div
                key={`${coord.productId}-${index}`}
                className="dot"
                style={{
                  left: `${coord.x}%`,
                  top: `${coord.y}%`,
                }}
              />
            ))}
        </div>

        <div className="creator-section">
          {look?.creator?.image && <img src={look.creator.image} alt={look.creator.name} className="creator-image" />}
          <div className="stl-text-container">
            <h3 className="title">{look?.title}</h3>
            <p className="thumb-creator-name">@{look?.creator?.name}</p>
          </div>
        </div>
      </div>
    </a>
  );
};

export default LookItem;
